module.exports = __webpack_public_path__ + "b8f7abf884165205d9ede06cd654f1ba.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/landing-page/landing-page.html
// module id = 1343
// module chunks = 0